export const useTabsConfig = () => {
  return [
    {
      title: 'Account',
      path: '/settings/account',
    },
  ];
};
